import { Link, useLocation } from 'react-router-dom'
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline'

interface BreadcrumbItem {
    label: string
    href?: string
}

interface BreadcrumbsProps {
    items?: BreadcrumbItem[]
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
    const location = useLocation()

    // Auto-generate breadcrumbs from path if not provided
    const generateBreadcrumbs = (): BreadcrumbItem[] => {
        if (items) return items

        const pathSegments = location.pathname.split('/').filter(Boolean)
        const breadcrumbs: BreadcrumbItem[] = [{ label: 'Dashboard', href: '/dashboard' }]

        const pathMap: Record<string, string> = {
            'users': 'Usuários',
            'aulas': 'Aulas',
            'questoes': 'Questões',
            'testes': 'Testes',
            'noticias': 'Notícias',
            'relatorios': 'Relatórios',
            'simulado': 'Simulado',
            'perfil': 'Perfil',
            'configuracoes': 'Configurações',
            'new': 'Novo',
            'edit': 'Editar'
        }

        pathSegments.forEach((segment, index) => {
            const label = pathMap[segment] || segment
            const href = index < pathSegments.length - 1 ? `/${pathSegments.slice(0, index + 1).join('/')}` : undefined
            breadcrumbs.push({ label, href })
        })

        return breadcrumbs
    }

    const breadcrumbs = generateBreadcrumbs()

    return (
        <nav className="flex mb-4" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-3">
                {breadcrumbs.map((item, index) => (
                    <li key={index} className="inline-flex items-center">
                        {index > 0 && (
                            <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" aria-hidden="true" />
                        )}
                        {item.href ? (
                            <Link
                                to={item.href}
                                className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary-600"
                            >
                                {index === 0 && <HomeIcon className="w-4 h-4 mr-1" aria-hidden="true" />}
                                {item.label}
                            </Link>
                        ) : (
                            <span className="inline-flex items-center text-sm font-medium text-gray-500" aria-current="page">
                                {index === 0 && <HomeIcon className="w-4 h-4 mr-1" aria-hidden="true" />}
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default Breadcrumbs
